<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-card-title>
			<h2>Lista wniosków placówki</h2>
		</v-card-title>
		<div>
			<v-card v-on:keyup.enter="buildNewSearch">
				<v-layout row justify-center align-center>
					<v-flex sm2>
						<v-text-field
							browser-autocomplete="off"
							class="ma-2"
							v-model="searchFields.projectCode"
							label="Nr wniosku"
							aria-label="project code"
							for="agency-all-projects-list-project-code"
							id="agency-all-projects-list-project-code"
						></v-text-field>
					</v-flex>
					<v-flex sm3>
						<v-autocomplete
							class="ma-2"
							v-model="searchFields.contestId"
							:items="contestNames"
							item-text="name"
							item-value="id"
							label="Nazwa naboru"
							aria-label="contest name"
							for="agency-all-projects-list-contest-names"
							id="agency-all-projects-list-contest-names"
						></v-autocomplete>
					</v-flex>
					<v-flex sm2>
						<v-select
							class="ma-2"
							v-model="searchFields.projectStatus"
							:items="statusList"
							label="Status wniosku"
							item-text="statusPL"
							item-value="statusEN"
							clearable
							aria-label="project status"
						></v-select>
					</v-flex>
					<v-flex sm3>
						<v-layout align-center justify-center>
							<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
							<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
							<v-btn @click="exportData" color="primary" dark class="ma-2">Eksportuj</v-btn>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card>
			<v-card>
				<v-data-table
					:headers="headers"
					:rows-per-page-items="[10,20,25]"
					:items="projects"
					:pagination.sync="pagination"
					:total-items="itemCount"
					class="elevation-1">
					<template v-slot:items="props">
						<td>{{ props.item.agencyProjectCode }}</td>
						<td>{{ props.item.name }}</td>
						<td>{{ props.item.contestName }}</td>
					<td>{{ formatMoneyWithCode(props.item.requestedDonation, props.item.currencyCode) }}</td>
					<td>{{ formatMoneyWithCode(props.item.ministerDonation, props.item.currencyCode) }}</td>
					<td>{{ getStatusName(props.item.status) }}</td>
						<td align="center">
							<v-icon small color="teal" class="mr-2" @click="editProject(props.item)"
								v-if="projectNotApproved(props.item) && !props.item.hideFromUser"
								:disabled="!editAllowed(props.item)"
								title="Edycja">edit
							</v-icon>
							<v-icon small class="mr-2" @click="viewProject(props.item)"
								v-if="!props.item.hideFromUser" title="Podgląd">
								description
							</v-icon>
							<v-icon small class="mr-2" color="red" v-if="!props.item.hideFromUser"
								:disabled="props.item.status !== 'NEW'"
								@click="deleteProject(props.item)" title="Usuń">delete
							</v-icon>
						</td>
					</template>
				</v-data-table>
			</v-card>
		</div>
	</div>

</template>

<script>
	import {Pagination} from "@/utils/PaginationUtils";
	import {Api} from "@/api";
	import {AgencyProject} from "@/api/generated/AgencyProject";
	import {ExportUtils} from "@/utils/ExportUtils";
  import {Filters} from "@/utils/Filters";
  import {Numbers} from "@/utils/Numbers";

	export default {
		name: "AgencyAllProjectsListView",

    mixins: [Filters, Numbers],

		data() {
			return {
				searchFields: Pagination.initSearchedFields([
					"projectCode",
					"contestId",
					"projectStatus",
				]),
				headers: [
					{text: "Numer wniosku", value: "projectCode", sortable: true},
					{text: "Nazwa wniosku", value: "title", sortable: true},
					{text: "Nazwa naboru", value: "contestName", sortable: true},
					{text: "Kwota wnioskowana", value: "requestedDonation", sortable: false},				{text: "Kwota przyznana", value: "ministerDonation", sortable: false},					{text: "Status wniosku", value: "projectStatus", sortable: true},
					{text: "Akcje", align: "center", value: "action", sortable: false},
				],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
					sortBy: null
				},
				projects: [],
				search: "",
				statusList: [
					{statusPL: "Nowy wniosek", statusEN: "NEW"},
					{statusPL: "Wysłany", statusEN: "SUBMITTED"},
					{statusPL: "Odrzucony", statusEN: "REJECTED"},
					{statusPL: "Oczekuje na poprawki", statusEN: "AWAITING_CORRECTION"},
					{statusPL: "Realizowany", statusEN: "APPROVED"},
					{statusPL: "Projekt oczekuje na poprawki", statusEN: "PROJECT_CHANGES_REQUESTED"},
					{statusPL: "Zakończony", statusEN: "FINISHED"},
					{statusPL: "Anulowany", statusEN: "ANNULLED"},
				],
				contestNames: []
			};
		},

    mounted() {
      this.searchFields = this.retrieveFilters(this.searchFields);
      this.pagination = this.retrievePagination(this.pagination);
      this.buildNewSearch();
    },

    watch: {
			"pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true,
			},
		},

		methods: {
			buildNewSearch() {
				this.search = this.buildSearch();
				this.getItemList();
			},

			buildSearch() {
				return Pagination.buildSearchCriteria(this.searchFields, false);
			},

			getItemList() {
				let sort = this.buildSort();
				AgencyProject.getAgencyProjectsContestNames(this, successResponse => {
						this.contestNames = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać listy nazw naboru", errorResponse);
					});
				Api.get(this,
					"/agency-agency-projects/list?search=" + this.search
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.projects = response.itemList;
							this.itemCount = response.itemCount;
						});
			},
			buildSort() {
				let order = this.pagination.descending === true ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			async resetSearch() {
				await Pagination.resetSearch(this.searchFields);
				this.search = "";
				this.getItemList();
			},

			exportData () {
				let search = this.search;
				let sort = this.buildSort();
				let endpointMainPath = "agency-agency-projects";
				let path = "/" + endpointMainPath + "/export?search=" + search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getStatusName(status) {
				return this.statusList.find(item => item.statusEN === status).statusPL;
			},

			projectNotApproved (project) {
				return !['APPROVED', 'PROJECT_CHANGES_REQUESTED', 'FINISHED'].includes(project.status);
			},

			editAllowed(project) {
				return project.status === "NEW" || project.status === "AWAITING_CORRECTION";
			},

			editProject(project) {
				this.$router.push("/app/agency-contest/" + project.contestId + "/project/" + project.id);
			},

			viewProject(project) {
				this.$router.openInNewTab("/view/agency-contest/" + project.contestId + "/project/" + project.agencyId + "/" + project.id);
			},

			deleteProject(projectId) {
				this.$confirm("Czy na pewno chcesz usunąć wniosek?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie wniosku",
					width: 500
				})
					.then(res => {
						if (res) {
							AgencyProject.delete(this, projectId, successResponse => {
									this.$emit("project-removed", projectId);
									this.$messagesBus.$emit("success", "Wniosek został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć wniosku", errorResponse);
								});
						}
					});
			},
		},
	};
</script>

<style scoped>

</style>